import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN";

import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

import FieldForceTxnDestAcc from "../FieldForceTxnDestAcc";
import CommonLayout from "../../_utils/CommonLayout";

const FieldForceCreateTxnSelectAccount = (props) => {
  const MIN_ASSOCIATES = GlobalConfiguration.lengthCheckOne;
  const dispatch = useDispatch();
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [bankLogo, setBankLogo] = useState(
    props?.txnPayLoad?.bankLogo ? props?.txnPayLoad?.bankLogo : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnPayLoad?.bankAccountNo ? props?.txnPayLoad?.bankAccountNo : "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [accountName, setAccountName] = useState(
    props?.txnPayLoad?.bankAccountName
      ? props?.txnPayLoad?.bankAccountName
      : "",
  );
  const [panNumber, setPanNumber] = useState(
    props?.txnPayLoad?.pan ? props?.txnPayLoad?.pan : null,
  );
  const [IFSC, setIFSC] = useState(
    props?.txnPayLoad?.bankAccountIFSC
      ? props?.txnPayLoad?.bankAccountIFSC
      : "",
  );

  const [activeType, setActiveType] = useState("pan");

  const { beneSuccessData } = useSelector(
    (state) => state?.beneCreateAccountSlice,
  );

  const { beneLookData } = useSelector((state) => state.verify);
  const bankData = useSelector(
    (state) => state?.beneAllVerification?.beneLookData,
  );

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > MIN_ASSOCIATES || havePANAssociate > MIN_ASSOCIATES) &&
    accountNumber &&
    IFSC;

  useEffect(() => {
    if (props?.associateModalOpen) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "auto";
    }
  }, [props?.associateModalOpen]);

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);

  useEffect(() => {
    if (props?.txnPayLoad?.pan) {
      dispatch(beneLookUp({ pan_number: props?.txnPayLoad?.pan }));
    }
  }, [props?.txnPayLoad?.pan]);

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    setAccountName(accountName);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);
    setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    const isRecreateFlow = props?.mapingData === "renderData";
    const isAccountChanged =
      props?.txnPayLoad?.beneAccountId &&
      props?.txnPayLoad?.beneAccountId !== beneAccountId;

    if (!isRecreateFlow || isAccountChanged) {
      props?.setSelectedCategory(null);
      props?.setCatShow(true);
      props?.setCatSelect(false);
    }

    dispatch(beneLookUp({ pan_number: panNo }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc,
        bank_account_no: accountNumber,
      }),
    );

    let matchedCategory = null;

    if (
      props?.type === "PayFieldForceTxn" &&
      categoriesArray.length > GlobalConfiguration?.lengthCheckZero
    ) {
      props?.setSelectedCategory({
        name: categoriesArray[0],
        configuration: props?.categories?.find((cat) =>
          cat?.category_name
            ?.toLowerCase()
            .includes(categoriesArray[0].toLowerCase()),
        )?.configuration,
      });
    }

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      selectedCategory: matchedCategory ?? null,
      amountWords: "",
      mergeCategory: null,
    }));
    props?.setAmountInWords("");
    handleCloseModal();

    if (beneSuccessData?.beneficiary_accounts?.[0]?.id !== beneAccountId) {
      props?.setAccountSelect(false);
      props?.setCatShow(true);
    }
  };

  useEffect(() => {
    if (props?.mapingData === "renderData" && props?.accountSelect) {
      handleAccountSelection(
        beneSuccessData?.beneficiary_accounts?.[0]?.name,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_acc_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.ifsc_code,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_name,
        beneSuccessData?.beneficiary_accounts?.[0]?.category,
        beneSuccessData?.beneficiary_accounts?.[0]?.pan_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.id,
        beneSuccessData?.beneficiary_accounts?.[0]?.labels,
      );
      props?.setCatShow(true);
    }
  }, [props?.mapingData, props?.accountSelect]);

  return (
    <>
      <div className="w-width-full  Qlg:px-padding-base px-padding-md Qsmd:pt-padding-lg pt-padding-md">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={props?.openOwner}
              setModalOpen={props?.setOpenOwner}
              txnPayLoad={props?.txnPayLoad}
              setTxnPayLoad={props?.setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
              TypeRTGS={props?.TypeRTGS}
              currentAccountDetails={props?.currentAccountDetails}
              isFieldforce={true}
            />
          </div>
          <div className="flex flex-col gap-gap-md">
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] ${
                props?.type === "PayFieldForceTxn"
                  ? "opacity-light-opacity pointer-events-none"
                  : !props?.txnPayLoad?.ownerBankAccountNo
                    ? "opacity-light-opacity pointer-events-none"
                    : "opacity-base-opacity"
              }`}
            >
              <FieldForceTxnDestAcc
                type="destination"
                flow="beneficiary"
                modalOpen={props?.isModalOpen}
                setModalOpen={props?.setIsModalOpen}
                txnPayLoad={props.txnPayLoad}
                setTxnPayLoad={props.setTxnPayLoad}
                shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
                handleOnAccountSelection={handleAccountSelection}
                setActiveType={setActiveType}
              />
            </div>
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
      </div>
    </>
  );
};

export default FieldForceCreateTxnSelectAccount;
